//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { apiUrl, apiParams } from '@/const/const';
import MyBtnReturn from '@/components/subComponents/MyBtnReturn';
import { directTurnIntoBase64, photoCompress, canvasDataURL } from '@/assets/js/util';
import uploadImg from '../../uploadImg/uploadImg.vue';

export default {
    name: 'LoadImgUploadZJDLD',
    components: {
        MyBtnReturn,
        uploadImg
    },
    data() {
        return {
            bookingId: '',
            ladingId: '',
            id: '',
            referenceno: '',
            contNo: '',
            contId: '',
            type: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的图片，右上角的icon
            uploadLoadSrc: require('@/assets/images/wx_zx_tp.png'), // 装箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: require('@/assets/images/wx_fx_tp.png'), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadLoaddocSrc: require('@/assets/images/wx_dz_tp.png'), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            imgSrc: '', // 一开始为uploadLoadSrc或uploadSealSrc，之后为用户上传的图片
            fileUrl: '', // 上传成功后返回的图片路径
            //iconClose: require('@/assets/images/wx_sc_oringe.png'), // 关闭图标
            iconClose2: require('@/assets/images/wx_sc_oringe.png'), // 关闭图标
            isShowLoading: false,
            canUpload: true,
            isUploaded: false, // 是否已经上传成功，true代表已经上传成了
            goBackQuery: {}, // 回退时要带的参数
            uploadUrl: '',
            step: -1,
            inputFiles: []
        };
    },
    created() {
        document.title = '装货图片';
        let query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.id = query.id;
        this.referenceno = query.referenceno;
        this.contNo = query.contNo;
        this.contId = query.contId;
        this.type = query.type;
        this.goBackQuery = {
            ladingId: query.ladingId,
            servicetype: query.servicetype
        };
        // todo:奇怪，到这个组件时(第四步)，微信中会清空apiParams，但apiUrl却正常
        // 出现上述bug的原因：页面的url被拼接了一个问号，变成/?#/这种情况，然后刷新一次页面，再进入这个组件，导致数据丢失，而且用go回退时要两次！
        // 上述Bug后，如果使用go回退，那apiParams里的属性在这里设置也没用，还是初始化为空字符串了，可能要保存在sessionStorage了，
        // 或者后台去将companyId与openId保存在session里
        // =>最新进展：后台保存在session里了
        if (!apiParams.companyId) {
            // 如果apiParams.companyId变回空字符串了，证明页面被刷新了
            console.error('companyId被弄没了');
            apiParams.companyId = query.companyId2;
            apiParams.openId = query.openId2;
            this.step = -2;
        }
        // 判断是装箱的，还是封箱的
        if (query.type === 'load') {
            let imgSrc = {
                imgSrc: this.uploadLoadSrc,
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(imgSrc);
            this.uploadUrl = apiUrl.loadImgUpload;
        } else if (query.type === 'seal') {
            let imgSrc = {
                imgSrc: this.uploadSealSrc,
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(imgSrc);
            this.uploadUrl = apiUrl.uploadSealController;
        } else {
            let imgSrc = {
                imgSrc: this.uploadLoaddocSrc,
                iconClose: null,
                flag: '0'
            };
            this.inputFiles.push(imgSrc);
            this.uploadUrl = apiUrl.loaddocUpload;
        }
    },
    methods: {
        uploadImg() {
            // 如果已经上传成功了，不给继续上传
            if (this.isUploaded) {
                this.showToast('已上传图片了，请返回上一页面继续操作！');
                return;
            }
            let imgs = [];
            let loadComplete = true;
            this.inputFiles.forEach((item, index) => {
                if (item.flag === '1') {
                    if (item.progress === 100) {
                        imgs.push({ img: item.imgSrc });
                    } else {
                        loadComplete = false;
                    }
                }
            });
            if (!loadComplete) {
                this.showToast('请等待照片上传完成！');
                return;
            }
            if (imgs.length === 0) {
                this.showToast('请选择照片再上传！');
                return;
            }
            this.$vux.loading.show({
                text: 'Loading'
            });
            let param = {
                base64Imgs: JSON.stringify(imgs), //多张图片
                companyId: apiParams.companyId,
                openId: apiParams.openId,
                bookingId: this.bookingId,
                ladingId: this.ladingId,
                id: this.id,
                referenceno: this.referenceno,
                cont_no: this.contNo
            };
            let url = this.uploadUrl;
            this.requestApi(
                {
                    url: url,
                    data: param
                },
                res => {
                    let code = res.code;
                    let info = res.data.info;

                    if (code === 412) {
                        // 412或500的提示语
                        this.showToast(info, 1500, 'warn');
                    } else if (code === 500) {
                        this.showToast(info, 1500, 'warn');
                    } else {
                        this.isUploaded = true;
                        if (info === '上传成功') {
                            let mes = '上传成功' + res.data.num.toString() + '张图片';
                            this.showToast(mes, 2000, 'success', {
                                onHide: () => {
                                    this.showToast('请返回上一页面继续操作。', 2000);
                                }
                            });
                        } else {
                            if (res.data.num > 0) {
                                let mes = '只上传成功' + res.data.num.toString() + '张(受总共最多上传30张的限制)';
                                this.showToast(mes, 5000, 'success', {
                                    onHide: () => {
                                        this.showToast('请返回上一页面继续操作。', 2000);
                                    }
                                });
                            } else {
                                this.showToast(info, 1500, 'warn');
                            }
                        }
                    }
                    this.canUpload = true;
                    this.$vux.loading.hide();
                },
                error => {
                    this.canUpload = true;
                    this.$vux.loading.hide();
                    if (error) {
                        console.error(error);
                        this.showToast('上传失败！', 2000, 'cancel');
                    }
                }
            );
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/siji/loadImg/LoadImgUploadZJDLD.vue